import { v4 as uuid4 } from "uuid";
import { JsonElement } from "../types";

export const createJsonElement = (id: string = uuid4()): JsonElement => ({
  id,
  kind: "json",
  data: "",
});
